export default function Hero() {
  return (
    <section className="relative min-h-screen bg-cream flex items-center overflow-hidden">
      {/* Subtle background texture accent */}
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(ellipse at 70% 50%, #E8DCC8 0%, transparent 65%)" }} />

      <div className="relative z-10 max-w-6xl mx-auto px-6 w-full pt-24 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left — Text Content */}
          <div className="flex flex-col order-2 lg:order-1 lg:mt-16 items-center lg:items-start text-center lg:text-left w-full">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-tight text-ink mb-14 w-full">
              Your <span className="relative inline-block">
                Next
                <svg className="absolute left-0 -bottom-4 w-full" viewBox="0 0 100 12" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" style={{height: '12px'}}>
                  <line x1="0" y1="3" x2="100" y2="2" stroke="#B5714A" strokeWidth="1.2" strokeLinecap="round"/>
                  <line x1="0" y1="9" x2="100" y2="8.5" stroke="#B5714A" strokeWidth="1.2" strokeLinecap="round"/>
                </svg>
              </span> Move
            </h1>

            <p className="font-sans text-xs tracking-widest2 uppercase text-ink/60 mb-8">
              For those navigating life&apos;s most defining moments.
            </p>

            <p className="font-sans text-lg md:text-xl font-light leading-loose text-ink max-w-md mb-16">
              You don&apos;t need more advice. You need the space and perspective to get clear, and the confidence to execute.
            </p>

            <div className="pt-10 border-t border-sand/60">
              <p className="font-sans text-sm md:text-base font-light text-ink/80 mb-8 leading-loose">You&apos;ve done the work and still find yourself questioning what&apos;s next. Together we&apos;ll bring clarity to your core challenge and uncover what&apos;s standing between you and your next move.</p>
              <div className="flex items-center gap-8">
                <div>
                  <p className="font-serif text-2xl font-light text-ink">30 min</p>
                  <p className="font-sans text-xs text-ink mt-0.5">Complimentary clarity session</p>
                </div>
                <div className="w-px h-10 bg-sand" />
                <div>
                  <p className="font-serif text-2xl font-light text-ink">1:1</p>
                  <p className="font-sans text-xs text-ink mt-0.5">1:1 Guided Support&nbsp;</p>
                </div>
                <div className="w-px h-10 bg-sand" />
                <div>
                  <p className="font-serif text-2xl font-light text-ink">Online</p>
                  <p className="font-sans text-xs text-ink mt-0.5">Join from wherever you are</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Name, Photo & Tagline Overlay */}
          <div className="order-1 lg:order-2 flex flex-col items-center">

            {/* Name — above the photo in serif font */}
            <div className="mb-5 text-center w-full">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-wide text-ink leading-none">
                Krystal Danielle
              </h2>
              <p className="font-sans text-xs tracking-widest2 uppercase text-ink/50 mt-3 tracking-[0.2em]">
                Life Coach
              </p>
            </div>

            {/* Image with tagline overlay only */}
            <div className="relative w-full max-w-sm lg:max-w-none lg:w-[440px]">
              {/* Decorative frame offset */}
              <div className="absolute -top-4 -right-4 w-full h-full border border-sand/60 rounded-none" />
              <div className="relative overflow-hidden" style={{ aspectRatio: "4/5" }}>
                <img
                  src="https://static.readdy.ai/image/e9a4567e546d09965afddf52525e12f0/d0bb5036de2fb148eb490c26662166b7.jpeg"
                  alt="Krystal Danielle — Life Coach &amp; Guide"
                  className="w-full h-full object-cover object-top"
                />
                {/* Gradient overlay for tagline readability */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-transparent" />

                {/* Tagline — centered in the photo */}
                <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
                  <p className="font-serif text-xl md:text-2xl lg:text-3xl font-light italic text-white leading-relaxed max-w-xs mx-auto drop-shadow-md tracking-wide">
                    <span className="block">Clarity for your vision.</span>
                    <span className="block">Wisdom for the journey.</span>
                  </p>
                </div>
              </div>

              {/* Floating accent quote */}
              <div className="absolute -bottom-6 -left-6 bg-white border border-sand/50 px-6 py-4 max-w-[200px] hidden lg:block">
                <p className="font-serif text-sm italic text-ink leading-snug">
                  &ldquo;Stop searching for the answer. Become the answer&rdquo;
                </p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
